/**
 * Nothing is written here, said on the same chrome as everything that is.
 *
 * The rail is dark on this board because no tab owns the path -- which is the honest answer,
 * and the reason `boardAt` is allowed to return nothing at all.
 */

import { Link } from "react-router-dom";
import Board from "../components/Board";

export default function NotFoundPage(): JSX.Element {
  return (
    <Board
      kicker="404"
      title="No such page"
      lede="Nothing is written here. The rail holds everything the app can show."
    >
      <Link
        to="/arrange"
        className="inline-flex min-h-[44px] items-center rounded-lg border border-rule bg-leaf px-4 text-sm text-clean-strong"
      >
        Back to Arrange
      </Link>
    </Board>
  );
}
